<template lang="pug">
  .login-account
    .error(v-if="errorMsg") {{ errorMsg }}

    .create-form
      form(v-on:keyup="checkSubmit" @click="clickEvent")
        label(:class="!accountInfo.name && submitCheck ? 'field-error' : ''") My Name
          input(type="text" v-model="accountInfo.name" :class="!accountInfo.name && submitCheck ? 'field-error' : ''")
        label(:class="!validEmail && submitCheck ? 'field-error' : ''") Email Address
          input(type="text" v-model="accountInfo.email" :class="!validEmail && submitCheck ? 'field-error' : ''")
        label(:class="!passwordLength && submitCheck ? 'field-error' : ''") Account Password
          input(type="password" v-model="accountInfo.password" :class="!passwordLength && submitCheck ? 'field-error' : ''")
        label(:class="!passwordLength && submitCheck ? 'field-error' : ''") Confirm Password
          input(type="password" v-model="accountInfo.confirmPassword" :class="!verifyPassword && submitCheck ? 'field-error' : ''")
        label(:class="!accountInfo.business && submitCheck ? 'field-error' : ''") Company Name
          input(type="text" v-model="accountInfo.business" :class="!accountInfo.business && submitCheck ? 'field-error' : ''")
        label(:class="!accountInfo.industry && submitCheck ? 'field-error' : ''") Industry
        .dropdown.select-industry
          span.header.toggleDropDown.primary(@click="clickDropDownToggle" :class="dropDownToggle ? 'open' : 'closed'") {{ accountInfo.primaryIndustry ? accountInfo.primaryIndustry : accountInfo.industry ? accountInfo.industry : 'Select One' }}
            svg(xmlns="http://www.w3.org/2000/svg" width="10.828" height="6.414" viewBox="0 0 10.828 6.414" :class="dropDownToggle ? 'flip' : ''")
              path(d="M3624.407,339.461l4,4,4-4" transform="translate(-3622.993 -338.047)" fill="none" stroke="#275181" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
          .options(v-if="dropDownToggle")
            span(@click="selectDropDown") Architect / Design
            span(@click="selectDropDown") Corporation
            span(@click="selectDropDown") Dealers
            span(@click="selectDropDown") Education
            span(@click="selectDropDown") Government
            span(@click="selectDropDown") Healthcare
            span(@click="selectDropDown") Hospitality
            span(@click="selectDropDown") Public Assembly
            span(@click="selectDropDown") Residential
            span(@click="selectDropDown") Restaurant
            span(@click="selectDropDown") Senior Living
            span(@click="selectDropDown") Worship / Church
        label(v-if="primaryArray.includes(accountInfo.industry) || primaryArray.includes(accountInfo.primaryIndustry)" :class="!accountInfo.primaryIndustry && submitCheck ? 'field-error' : ''") Sub Industry
        .dropdown.select-sub-industry(v-if="primaryArray.includes(accountInfo.industry) || primaryArray.includes(accountInfo.primaryIndustry)")
          span.header.toggleDropDown.secondary(@click="clickSubDropDownToggle" :class="subDropDownToggle ? 'open' : 'closed'") {{ accountInfo.primaryIndustry == '' ? 'Select One' : accountInfo.industry }}
            svg(xmlns="http://www.w3.org/2000/svg" width="10.828" height="6.414" viewBox="0 0 10.828 6.414" :class="subDropDownToggle ? 'flip' : ''")
              path(d="M3624.407,339.461l4,4,4-4" transform="translate(-3622.993 -338.047)" fill="none" stroke="#275181" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
          .options(v-if="subDropDownToggle && accountInfo.industry == 'Architect / Design' || subDropDownToggle && accountInfo.primaryIndustry == 'Architect / Design'")
            span(@click="selectSubDropDown") Hospitality Design
            span(@click="selectSubDropDown") Senior Living Design
            span(@click="selectSubDropDown") Other Design
          .options(v-else-if="subDropDownToggle && accountInfo.industry == 'Dealers' || subDropDownToggle && accountInfo.primaryIndustry == 'Dealers'")
            span(@click="selectSubDropDown") Office Product Dealers
            span(@click="selectSubDropDown") Education Only Dealers
            span(@click="selectSubDropDown") Food Service Dealers
            span(@click="selectSubDropDown") Other Dealers
          .options(v-else-if="subDropDownToggle && accountInfo.industry == 'Hospitality' || subDropDownToggle && accountInfo.primaryIndustry == 'Hospitality'")
            span(@click="selectSubDropDown") Country Club
            span(@click="selectSubDropDown") Food Service Dealers
            span(@click="selectSubDropDown") Hotel Management
            span(@click="selectSubDropDown") Hotel Full Service
            span(@click="selectSubDropDown") Hotel Select / Limited Service
            span(@click="selectSubDropDown") Purchasing Group
            span(@click="selectSubDropDown") Ownership & Management Group
            span(@click="selectSubDropDown") Other Hospitality
          .options(v-else-if="subDropDownToggle && accountInfo.industry == 'Public Assembly' || subDropDownToggle && accountInfo.primaryIndustry == 'Public Assembly'")
            span(@click="selectSubDropDown") Convention, Conference & Civic Centers
            span(@click="selectSubDropDown") Performing Arts
            span(@click="selectSubDropDown") Stadiums & Arenas
            span(@click="selectSubDropDown") Other Public Assembly
        label.tax-exempt
          input(type="checkbox" v-model="accountInfo.taxExempt")
          span We are Tax-Exempt <em>(Verification required)</em>
        label(:class="!validPhoneNumber && submitCheck ? 'field-error' : ''") Phone Number
          input(type="tel" v-model="accountInfo.phoneNumber" :class="!validPhoneNumber && submitCheck ? 'field-error' : ''")
        
        label Delivery Address
        label(:class="!accountInfo.street && submitCheck ? 'field-error' : ''") Street
          input(type="text" v-model="accountInfo.street" :class="!accountInfo.street && submitCheck ? 'field-error' : ''")
        label(:class="!accountInfo.city && submitCheck ? 'field-error' : ''") City
          input(type="text" v-model="accountInfo.city" :class="!accountInfo.city && submitCheck ? 'field-error' : ''")
        
        label(:class="!accountInfo.country && submitCheck ? 'field-error' : ''") Country 
        .dropdown.select-country
          span.header.toggleDropDown.primary(@click="clickCountryDropDownToggle()" :class="countryDropDownToggle ? 'open' : 'closed'") {{ accountInfo.country ? accountInfo.country : 'Select Country' }}
            svg(xmlns="http://www.w3.org/2000/svg" width="10.828" height="6.414" viewBox="0 0 10.828 6.414" :class="countryDropDownToggle ? 'flip' : ''")
              path(d="M3624.407,339.461l4,4,4-4" transform="translate(-3622.993 -338.047)" fill="none" stroke="#275181" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
          .options.country-drop-down(v-if="countryDropDownToggle")
            span(v-for="country in addressCountries" v-bind:key="country.iso2" :value="country.iso2" @click="selectCountry") {{ country.name }}
        
        div(v-if="addressStates.length > 0")
          label(:class="!accountInfo.state && submitCheck ? 'field-error' : ''") State / Province
          .dropdown.select-state
            span.header.toggleDropDown.primary(@click="clickStateDropDownToggle()" :class="stateDropDownToggle ? 'open' : 'closed'") {{ accountInfo.state ? accountInfo.state : 'Select State' }}
              svg(xmlns="http://www.w3.org/2000/svg" width="10.828" height="6.414" viewBox="0 0 10.828 6.414" :class="stateDropDownToggle ? 'flip' : ''")
                path(d="M3624.407,339.461l4,4,4-4" transform="translate(-3622.993 -338.047)" fill="none" stroke="#275181" stroke-linecap="round" stroke-linejoin="round" stroke-width="2")
            .options.state-drop-down(v-if="stateDropDownToggle")
              span(v-for="state in addressStates" v-bind:key="state.iso2" :value="state.iso2" @click="selectState") {{ state.name }}

        div(v-if="stateFetchFail")
          label(:class="!accountInfo.state && submitCheck ? 'field-error' : ''") State / Province
            input(type="text" v-model="accountInfo.state" :class="!accountInfo.state && submitCheck ? 'field-error' : ''")

        label(:class="!validPostalCode && submitCheck ? 'field-error' : ''") Postal Code
          input(type="text" v-model="accountInfo.postalCode" :class="!validPostalCode && submitCheck ? 'field-error' : ''")
        button(type="button" @click="verifyInfo") Create An Account
</template>

<script>
import { Quotes } from "../scripts/quotes.js";
import Accounts from "../scripts/accounts.js";
import Activity from "../scripts/activity.js";
import { Country } from "../scripts/country-state";

export default {
  name: "CreateAccount",
  data() {
    return {
      errorMsg: "",
      accountInfo: {},
      submitCheck: false,
      dropDownToggle: false,
      countryDropDownToggle: false,
      stateDropDownToggle: false,
      stateFetchFail: false,
      subDropDownToggle: false,
      duplicatedEmail: false,
      passwordWeak: false,
      primaryArray: [
        "Architect / Design",
        "Dealers",
        "Hospitality",
        "Public Assembly"
      ],
      addressCountries: {},
      addressStates: {}
    };
  },
  computed: {
    validPostalCode() {
      var zip = this.accountInfo.postalCode;

      var us = /^([0-9]{5})(?:[-\s]*([0-9]{4}))?$/; // USA
      var canada = /^[A-Za-z]\d[A-Za-z][ -]?\d[A-Za-z]\d$/; // Canada
      var uk = /^([A-Za-z]{1,2}\d[A-Za-z\d]? \d[A-Za-z]{2}|GIR 0AA)$/; // UK
      var australia = /^\d{4}$/; // Australia
      var multi = /^\d{5}$/; // France, Germany, Italy, Mexico
      var japan = /^\d{3}-\d{4}$/; // Japan
      var netherlands = /^\d{4} ?[A-Za-z]{2}$/; // Netherlands
      var brazil = /^\d{5}-\d{3}$/; // Brazil

      return (
        us.test(zip) ||
        canada.test(zip) ||
        uk.test(zip) ||
        australia.test(zip) ||
        multi.test(zip) ||
        japan.test(zip) ||
        netherlands.test(zip) ||
        brazil.test(zip)
      );
    },
    validEmail() {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(this.accountInfo.email).toLowerCase());
    },
    passwordLength() {
      if (this.accountInfo.password) {
        if (this.accountInfo.password.length >= 6) {
          return true;
        } else {
          return false;
        }
      } else {
        return false;
      }
    },
    verifyPassword() {
      if (this.accountInfo.password != this.accountInfo.confirmPassword) {
        return false;
      } else {
        return true;
      }
    },
    validPhoneNumber: function() {
      if (
        /^[(]{0,1}[0-9]{3}[)]{0,1}[-\s\.]{0,1}[0-9]{3}[-\s\.]{0,1}[0-9]{4}$/.test(
          this.accountInfo.phoneNumber
        ) != false
      ) {
        return true;
      } else {
        return false;
      }
    }
  },
  methods: {
    verifyInfo() {
      this.submitCheck = true;
      this.duplicatedEmail = false;
      this.passwordWeak = false;

      if (
        this.validEmail &&
        this.validPhoneNumber &&
        this.passwordLength &&
        this.verifyPassword &&
        this.validPostalCode &&
        this.accountInfo.business &&
        this.accountInfo.city &&
        this.accountInfo.country &&
        this.accountInfo.industry &&
        this.accountInfo.name &&
        (this.accountInfo.state || this.addressStates.length == 0) &&
        this.accountInfo.street &&
        !this.primaryArray.includes(this.accountInfo.industry)
      ) {
        this.errorMsg = "";
        this.submitCreateAccount();
      } else {
        var myDiv = document.getElementsByClassName("mity-quotes")[0];
        myDiv.scrollTop = 0;
        this.errorMsg = "Please correct all invalid fields";
      }
    },
    submitCreateAccount: function() {
      Accounts.createAccount(this.accountInfo)
        .then(uid => {
          this.$root.currentUser = {
            name: this.accountInfo.name,
            uid: uid,
            guest: false
          };

          // Save Guest Draft Quote
          if (
            sessionStorage.getItem("draft_quotes") &&
            sessionStorage.getItem("draft_quotes") !== "undefined"
          ) {
            var session = JSON.parse(sessionStorage.getItem("draft_quotes"));
            session.forUser = uid;

            Quotes.createQuote(session);
            this.$root.activeDraft = session;

            if (this.$parent.$options.name == "Authentication") {
              this.$root.confirmation.msg = "Setup Complete!";
              this.$root.confirmation.returnState = "quotes";
              this.$root.confirmation.returnMsg = "View Cart";
              this.$root.confirmation.open = true;
            } else if (this.$parent.$options.name == "Cart") {
              this.$parent.addressState = "existing-account";
              this.$parent.step = 2;
              this.$parent.subView = "contact";
              this.$parent.getAccount();
            }
          } else {
            this.$root.confirmation.msg = "Setup Complete!";
            this.$root.confirmation.returnState = "quotes";
            this.$root.confirmation.returnMsg = "View Cart";
            this.$root.confirmation.open = true;
          }

          Account.updateLastLogin(this.$root.currentUser);
          Activity.userActivity(
            this.$root.currentUser,
            "user:new",
            this.accountInfo
          );
        })
        .catch(error => {
          var myDiv = document.getElementsByClassName("mity-quotes")[0];
          myDiv.scrollTop = 0;

          if (
            error.code == "auth/email-already-in-use" ||
            error.code == "auth/invalid-email"
          ) {
            this.duplicatedEmail = true;
            this.errorMsg = error.message;
          } else if (error.code == "auth/argument-error") {
            this.duplicatedEmail = true;
            this.errorMsg = "Email is not a valid string";
          } else if (error.code == "auth/weak-password") {
            this.passwordWeak = true;
            this.errorMsg = error.message;
          } else if (error.code == "db/user-save-failed") {
            this.errorMsg = "Create account failed, please try again.";
          } else {
            this.errorMsg = "Invalid entry, please try again.";
          }
        });
    },
    selectSubDropDown(e) {
      this.subDropDownToggle = false;
      if (!this.accountInfo.primaryIndustry) {
        this.accountInfo.primaryIndustry = this.accountInfo.industry;
      }
      this.accountInfo.industry = e.target.innerText;
    },
    selectCountry(e) {
      this.accountInfo.country = e.target.innerText;
      this.accountInfo.countryAbbr = e.target.getAttribute("value");
      this.accountInfo.state = "";
      this.clickCountryDropDownToggle();
      Country.getStatesOfCountry(this.accountInfo.countryAbbr).then(states => {
        if (states.length > 0) {
          this.stateFetchFail = false;
        } else {
          this.stateFetchFail = true;
        }
        this.addressStates = states.sort((a, b) => (a.name > b.name ? 1 : -1));
      });
    },
    selectState(e) {
      this.accountInfo.state = e.target.getAttribute("value");
      this.clickStateDropDownToggle();
    },
    selectDropDown(e) {
      this.dropDownToggle = false;
      this.accountInfo.industry = e.target.innerText;
      this.accountInfo.primaryIndustry = "";
    },
    clickEvent(e) {
      if (e.target.classList.length === 0) {
        this.dropDownToggle = false;
        this.stateDropDownToggle = false;
        this.subDropDownToggle = false;
        this.countryDropDownToggle = false;
      }
    },
    clickDropDownToggle() {
      this.dropDownToggle = !this.dropDownToggle;
      this.subDropDownToggle = false;
      this.countryDropDownToggle = false;
      this.stateDropDownToggle = false;
    },
    clickSubDropDownToggle() {
      this.subDropDownToggle = !this.subDropDownToggle;
      this.dropDownToggle = false;
      this.countryDropDownToggle = false;
      this.stateDropDownToggle = false;
    },
    clickCountryDropDownToggle() {
      this.countryDropDownToggle = !this.countryDropDownToggle;
      this.dropDownToggle = false;
      this.subDropDownToggle = false;
      this.stateDropDownToggle = false;
    },
    clickStateDropDownToggle() {
      this.stateDropDownToggle = !this.stateDropDownToggle;
      this.dropDownToggle = false;
      this.subDropDownToggle = false;
      this.countryDropDownToggle = false;
    },
    checkSubmit(e) {
      if (e && e.keyCode == 13) {
        this.verifyInfo();
      }
    }
  },
  created: function() {
    this.$root.currentPage = "Create Account";

    //Sort United States and Canada to Top of Array List
    Country.getAllCountries().then(countries => {
      this.addressCountriesData = countries;

      for (var data in this.addressCountriesData) {
        if (
          this.addressCountriesData[data].name == "United States" ||
          this.addressCountriesData[data].name == "Canada"
        ) {
          var tmp = this.addressCountriesData[data];

          this.addressCountriesData.splice(data, 1);
          this.addressCountriesData.unshift(tmp);
        }
      }

      this.addressCountries = this.addressCountriesData;
    });
  }
};
</script>

<style lang="scss">
@import "../assets/styles/variables.scss";

#app {
  .error {
    margin-top: 1em;
  }

  form {
    margin: 1em 0;
    label {
      display: block;
      font-size: 0.9em;
      margin: 0.8em 0;
    }

    input {
      border: 1px $border_gray solid;
      border-radius: 7px;
      padding: 1em 0.5em;
      position: relative;
      width: 100%;
    }

    input[type="checkbox"] {
      height: 20px;
      width: 20px;
    }

    .dropdown {
      position: relative;
      width: 100%;
      span {
        border: 1px $light_gray solid;
        cursor: pointer;
        display: block;
        font-size: 0.9em;
        margin-top: -1px;
        padding: 1em;

        &:hover {
          background: #f6e4c1;
        }
      }
      .header {
        background: $light_gray;
        border-radius: 5px;

        &.open {
          border-radius: 5px 5px 0 0;
        }
        svg {
          float: right;
          height: 15px;
          width: 15px;
          &.flip {
            transform: rotate(180deg);
          }
        }
      }
      .options {
        background: #fff;
        position: absolute;
        width: 100%;
        z-index: 10;

        span:last-of-type {
          border-radius: 0 0 5px 5px;
        }
      }
    }

    .tax-exempt {
      align-items: center;
      display: flex;
      font-size: 0.8em;
      margin: 1.3em 0;

      input {
        margin-top: 0;
        margin-right: 0.7em;
        margin-bottom: 0em;
      }

      em {
        font-size: 0.9em;
      }
    }

    label.field-error {
      color: red;
    }
    input.field-error,
    select.field-error {
      border: 1px solid red;
    }
  }
}
</style>
